module.exports = __webpack_public_path__ + "img/filter.453f79e4.svg";